import { FaChartBar } from "react-icons/fa";
import { FaDiagramProject } from "react-icons/fa6";
import { LuTextQuote } from "react-icons/lu";
import { IoCreate } from "react-icons/io5";
import { HiBuildingOffice } from "react-icons/hi2";
import { GrProjects } from "react-icons/gr";
import { BsBarChartSteps } from "react-icons/bs";
import { IoMdSettings } from "react-icons/io";
import { RiFolderReceivedFill } from "react-icons/ri";
import { FaListUl } from "react-icons/fa";


export const NewMenuItems = [
  {
    id: 1,
    label: 'Projet Un Click',
    icon: <GrProjects />,
    subMenu: [
      {
        id:11,
        label:'Statistique',
        link:'/',
        icon: <FaChartBar />
      },
      {
        id:12,
        label:'Devis',
        link:'/quote',
        icon: <FaDiagramProject />
      },
      {
        id:13,
        label:'Projets',
        link:'/project',
        icon: <LuTextQuote />
      },
      {
        id:14,
        label:'Créer un Projet',
        link:'/projet',
        icon: <IoCreate />
      },
    ]
  },

  {
    id: 2,
    label: 'Bureau d\'Etude',
    icon: <HiBuildingOffice />,
    subMenu: [
      {
        id:21,
        label:'Statistique',
        link:'/stats',
        icon: <FaChartBar />
      
      },
      // {
      //   id:22,
      //   label:'Etapes',
      //   link:'/bureau-etude',
      //   icon: <BsBarChartSteps />
      // },
      {
        id:23,
        label:'Projets',
        link:'/projectbe',
        icon: <LuTextQuote />
      },
      {
        id:24,
        label:'Projets Soumis',
        link:'/be-projects',
        // icon: <FaListUl />,
        icon: <RiFolderReceivedFill />
      },
      {
        id:25,
        label:'Créer un Projet',
        link:'/select-project',
        icon: <IoCreate />
      },
    ],
  },

  // {
  //   id: 3,
  //   label: 'Soumissions BE',
  //   icon: <RiFolderReceivedFill />,
  //   subMenu: [],
  //   link: '/submissions',
  // },

  {
    id: 3,
    label: 'Paramètres',
    icon: <IoMdSettings />,
    subMenu: [],
    link: '/settings',
  },
]